import httpService from "@/utils/services/http_service";

export default {
  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  管理员列表
   */
  async memberList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_member_list',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  管理员列表
   */
  async addMember(data = {}) {
    return httpService.post(
      '/api.php?do=admin_member_create',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  管理员列表
   */
  async editMember(data = {}) {
    return httpService.post(
      '/api.php?do=admin_member_edit',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  管理员列表
   */
  async deleteMember(data = {}) {
    return httpService.post(
      '/api.php?do=admin_member_delete',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-04
   *  管理员列表
   */
  async appList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_app_list',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-04
   *  管理员列表
   */
  async addApp(data = {}) {
    return httpService.post(
      '/api.php?do=admin_app_create',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-04
   *  管理员列表
   */
  async editApp(data = {}) {
    return httpService.post(
      '/api.php?do=admin_app_edit',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-04
   *  管理员列表
   */
  async deleteApp(data = {}) {
    return httpService.post(
      '/api.php?do=admin_app_delete',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-04
   *  管理员列表
   */
  async resetToken(data = {}) {
    return httpService.post(
      '/api.php?do=admin_app_token_reset',
      data
    )
  },

  /**
   * @author: lafitewu
   * date: 2020-05-10
   *  企业列表
   */
  async businessManagement(data = {}) {
    return httpService.post(
      '/api.php?do=admin_company_list',
      data
    )
  },

  async businessManagementG(data = {}) {
    return httpService.post(
      '/api.php?do=admin_gov_list',
      data
    )
  },

  async deleteCompany(data = {}) {
    return httpService.post(
      '/api.php?do=admin_company_delete',
      data
    )
  },

  async deleteCompanyG(data = {}) {
    return httpService.post(
      '/api.php?do=admin_gov_delete',
      data
    )
  },

  async addCompany(data = {}) {
    return httpService.post(
      '/api.php?do=admin_company_add',
      data
    )
  },

  async addCompanyG(data = {}) {
    return httpService.post(
      '/api.php?do=admin_gov_add',
      data
    )
  },

  async editCompany(data = {}) {
    return httpService.post(
      '/api.php?do=admin_company_edit',
      data
    )
  },

  async editCompanyG(data = {}) {
    return httpService.post(
      '/api.php?do=admin_gov_edit',
      data
    )
  },

  async infoCompany(data = {}) {
    return httpService.post(
      '/api.php?do=admin_company_info',
      data
    )
  },

  // 1.6 2020-11-02 新增 by lafitewu
  // async companyMemberList(data = {}) {
  //   return httpService.post(
  //     '/api.php?do=company_member_list',
  //     data
  //   )
  // },
  async rightcodeList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_edition_rightcode_list',
      data
    )
  },
  async rightcodeListG(data = {}) {
    return httpService.post(
      '/api.php?do=admin_gov_edition_rightcode_list',
      data
    )
  },
  async memberCodeList(data = {}) {
    return httpService.post(
      '/api.php?do=company_member_rightcode_list',
      data
    )
  },
  async adminCompanyInfo(data = {}) {
    return httpService.post(
      '/api.php?do=admin_company_info',
      data
    )
  },
  async adminCompanyInfoG(data = {}) {
    return httpService.post(
      '/api.php?do=admin_gov_info',
      data
    )
  },
  async controlList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_edtion_control_list',
      data
    )
  },
  async controlListG(data = {}) {
    return httpService.post(
      '/api.php?do=admin_gov_edtion_control_list',
      data
    )
  },
  async controlConfig(data = {}) {
    return httpService.post(
      '/api.php?do=admin_edtion_control_config',
      data
    )
  },
  async controlConfigG(data = {}) {
    return httpService.post(
      '/api.php?do=admin_gov_edtion_control_config',
      data
    )
  },
  async controlInfo(data = {}) {
    return httpService.post(
      '/api.php?do=admin_edtion_control_info',
      data
    )
  },
  async controlInfoG(data = {}) {
    return httpService.post(
      '/api.php?do=admin_gov_edtion_control_info',
      data
    )
  },
  // 通用设置，获取涉及国家下拉列表
  async adminAreaList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_list',
      data
    )
  },
  // 通用设置，获取大屏信息下拉列表
  async adminBoardConfigList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_board_config_list',
      data
    )
  },
}
